import { LANG_ATTRIBUTE } from '@/utils/constants';

const resolveDate = ({ rawVal }: DateProps) => {
  if (!rawVal) return '';

  return new Date(rawVal).toLocaleDateString(LANG_ATTRIBUTE, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export default resolveDate;
